import { render } from "./index.vue?vue&type=template&id=ad68175e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ad68175e&lang=scss"
script.render = render

export default script